
import React from "react";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Slider } from "@/components/ui/slider";
import { NumericInput } from "@/components/ui/numeric-input";
import type { MortgageData } from "../../CalculatorTabs";
import { calculateMortgageData } from "@/utils/calculator/mortgageCalculator";
import { AutoCalculateOptions } from "../../utils/types";
import { formatCurrency, parseCurrency } from "../../utils/formatters";
import { MetricTooltip } from "../../advanced/analytics/MetricTooltip";

interface InsuranceInputProps {
  mortgageData: MortgageData;
  setMortgageData: React.Dispatch<React.SetStateAction<MortgageData>>;
  autoCalculate: AutoCalculateOptions;
  setAutoCalculate: React.Dispatch<React.SetStateAction<AutoCalculateOptions>>;
}

const InsuranceInput: React.FC<InsuranceInputProps> = ({ 
  mortgageData, 
  setMortgageData, 
  autoCalculate, 
  setAutoCalculate 
}) => {
  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-2">
          <Label className="text-sm font-medium">Annual Insurance <MetricTooltip metric="annualInsurance" /></Label>
          <div className="flex items-center space-x-2">
            <Switch
              checked={autoCalculate.insurance}
              onCheckedChange={(checked) => {
                setAutoCalculate(prev => ({
                  ...prev,
                  insurance: checked
                }));
              }}
            />
            <span className="text-xs text-homebuyer-gray">Auto</span>
          </div>
        </div>
        <NumericInput 
          value={mortgageData.homeInsurance}
          onChange={(value) => {
            setMortgageData(prev => calculateMortgageData({
              ...prev,
              homeInsurance: value
            }));
          }}
          formatValue={formatCurrency}
          parseValue={parseCurrency}
          min={0}
          max={25000}
          disabled={autoCalculate.insurance}
          className="w-36"
          inputClassName="text-right overflow-ellipsis"
        />
      </div>
      <Slider
        defaultValue={[mortgageData.homeInsurance]}
        min={0}
        max={10000}
        disabled={autoCalculate.insurance}
        step={100}
        value={[mortgageData.homeInsurance]}
        onValueChange={(value) => {
          const newValue = Array.isArray(value) ? value[0] : value;
          setMortgageData(prev => calculateMortgageData({
            ...prev,
            homeInsurance: newValue
          }));
        }}
        className="my-4"
      />
    </div>
  );
};

export default InsuranceInput;
